angular.module('bmsApp.fees')
	.controller('SlidingFeeBreakdownModalCtrl', SlidingFeeBreakdownModalCtrl);

SlidingFeeBreakdownModalCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'fee',
	'readonlyForm',
	'$modalInstance',
	'scales',
	'$window',
	'$timeout',
	'notify',
	'FranchiseSvc',
	'FeeSvc',
	'InstanceSvc'
];


function SlidingFeeBreakdownModalCtrl($scope, $state, $q, fee, readonlyForm, $modalInstance, scales, $window, $timeout, notify, FranchiseSvc,FeeSvc, InstanceSvc) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: null,
		uploadingFiles: false,
		handlers: handlers,
		breakdown: {
			documents:[],
		},
		feeBreakdowns: [],
	});

	function calculate() {

		self.total_fee = 0;
		self.breakdown.total_fee = (parseFloat(self.breakdown.local_sales_monthly_billing) || 0);
		var feeReminder = self.breakdown.total_fee;
		self.feeBreakdowns = [];
		angular.forEach(scales, (scale) => {

			if (scale.allocatable > 0) {
				let allocation = Math.min(feeReminder, scale.allocatable);
				feeReminder -= allocation;
				let allocationRoyaltyNet = allocation * scale.percentage / 100;

				let feeBreakdownItem = {
					percentage: scale.percentage,
					royalty_net: allocationRoyaltyNet,
					allocation: allocation,
				};
				self.total_fee += allocationRoyaltyNet;
				self.feeBreakdowns.push(feeBreakdownItem);
			}
		});
	}

	function CalculateSalesCode() {
		var totalSales = 0;
		angular.forEach(self.fee.sales_breakdowns, function(salesBreakdown){
			if(salesBreakdown.sales_code.requires_addition){
				totalSales += (parseFloat(salesBreakdown.amount) || 0);
			}
		});
		self.breakdown.local_sales_monthly_billing = totalSales;
		calculate();
	}

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.onInit = () => {
		self.scales = scales;
		self.readonly = readonlyForm;
		self.fee = fee;
		self.fee.no_fee_applied = false;
		self.isRB = InstanceSvc.instance.isRB();
		if (InstanceSvc.instance.isRB()) {
			if (!self.fee.sales_breakdowns) {
				self.loading = true;
				FranchiseSvc.salesCodes()
					.then((response) => {
						self.salesCodes = response.data.sales_codes;
						var sales_breakdowns = [];
						angular.forEach(self.salesCodes, function(salesCode){
							sales_breakdowns.push({
								id: null,
								sales_code: salesCode,
								amount: 0
							});
						});
						self.fee.sales_breakdowns = sales_breakdowns;
						self.loading = false;

					});

			}
		}
		if(angular.isUndefined(self.fee.documents)){
			self.fee.documents = [];
		}
		if (!angular.isObject(fee.license_breakdown)) {
			angular.extend(fee, {
				license_breakdown: {},
			});
			self.breakdown = angular.copy(fee.license_breakdown);

		}
		else {
			self.breakdown = angular.copy(fee.license_breakdown);
			calculate();
		}

		$scope.dropzoneErrors = [];
		$scope.dropzone = {
			config: {
				url: 'api/fees/upload-expense',
				parallelUploads: 3,
				maxFileSize: 5,
				acceptedFiles: '.csv, .xls, .xlsx, .jpg, .jpeg, .png, .doc, .docx, .pdf',
				eventHandlers: {
					processingmultiple: function (event) {
						$timeout(function () {
							self.uploadingFiles = true;
						}, 0);
					},
					processing: function (event) {
						$timeout(function () {
							self.uploadingFiles = true;
						}, 0);

					},
					sending: function (event) {
						$timeout(function () {
							self.uploadingFiles = true;
						}, 0);
					},
					addedfile: function (event) {
						$timeout(function () {
							self.uploadingFiles = true;
						}, 0);

					},
					drop: function (event) {
						$timeout(function () {
							self.uploadingFiles = true;
						}, 0);
						$scope.dropzoneErrors = [];
					},
					queuecomplete: function () {
						this.removeAllFiles(); // empty the dropzone
						$timeout(function () {
							self.uploadingFiles = false;
						}, 0);
					},
					success: function (file, response) {
						$timeout(function () {
							self.fee.documents.push({
								file: response.file
							});
						}, 0);
					},
					error: function (file, error) {
						$scope.dropzoneErrors.push(error.errors[0]);
					}
				}
			}
		};

	};

	handlers.onCalculate = () => {
		calculate();
	};

	handlers.onCalculateSalesCode = () => {
		CalculateSalesCode();
	};

	handlers.onCancel = () => {
		$modalInstance.dismiss('cancel');
	};

	handlers.submitZeroClick = function() {
		// if(self.fee.minimum_fee != 0){
		// 	notify({
		// 		message: 'Minumum fee submission is £' + self.fee.minimum_fee,
		// 		classes: 'error',
		// 	});
		// 	return;
		// }

		angular.extend(fee, {
			no_fee_applied: true,
			license_breakdown: {
				total_fee: 0
			}
		});
		$modalInstance.close(fee);
	};

	handlers.submitClick = function () {
		// if(!self.total_fee || self.total_fee < self.fee.minimum_fee){
		// 	notify({
		// 		message: 'Minumum fee submission is £' + self.fee.minimum_fee.toFixed(2),
		// 		classes: 'error'
		// 	});
		// 	return;
		// }
		angular.extend(fee, {
			license_breakdown: self.breakdown,
			documents: self.fee.documents,
		});
		$modalInstance.close(fee);
	};

	handlers.downloadAttachment = function(filename) {
		$window.open('file/download/n/'+filename+'/mode/0/disk/', '_blank');
	}

}
